module.exports = __webpack_public_path__ + "static/waterproof-mattress-protector-3-c13f53ab412c986bbeec4b38d5ca0f28.webp";